// https://vuex.vuejs.org/en/actions.html
import { API } from 'aws-amplify'
import { ErrorMessageHelper } from '../../../errorMessageHelper'

export default {
  cleanDossiersListMemory (context) {
    context.commit('listDossiersRecords', [])
  },
  listAllDossiersForAClient (context, params) {
    context.commit('listDossiersState', 'in-progress')
    return API.get('worktools', '/clients/' + params.clientId + '/dossiers', {}).then(response => {
      context.commit('listDossiersState', 'ok')
      context.commit('listDossiersRecords', response)
    }).catch(error => {
      context.commit('listDossiersState', 'error')
      ErrorMessageHelper(context, 'Impossible de lister les dossiers d\'un client.')
      return Promise.reject(error)
    })
  },
  addDossier (context, params) {
    context.commit('addDossiersState', 'in-progress')
    return API.post('worktools', '/clients/' + params.clientId + '/dossiers', {
      body: {
        libelle: params.libelle,
        couleur: params.couleur ? params.couleur : null,
        numero: params.numero ? params.numero : null
      }
    }).then(response => {
      context.commit('addDossiersState', 'ok')
      context.dispatch('listAllDossiersForAClient', { clientId: params.clientId })
    }).catch(error => {
      context.commit('addDossiersState', 'error')
      ErrorMessageHelper(context, 'Impossible d\'ajouter un dossier au client.')
      return Promise.reject(error)
    })
  },
  editDossier (context, params) {
    context.commit('editDossierState', 'in-progress')
    return API.put('worktools', '/clients/' + params.clientId + '/dossiers/' + params.dossierId, {
      body: {
        libelle: params.libelle,
        couleur: params.couleur ? params.couleur : null,
        numero: params.numero ? params.numero : null
      }
    }).then(response => {
      context.commit('editDossierState', 'ok')
      context.dispatch('listAllDossiersForAClient', { clientId: params.clientId })
    }).catch(error => {
      context.commit('editDossierState', 'error')
      ErrorMessageHelper(context, 'Impossible de modifier les dossier client.')
      return Promise.reject(error)
    })
  },
  removeDossier (context, params) {
    context.commit('editDossierState', 'in-progress')
    return API.del('worktools', '/clients/' + params.clientId + '/dossiers/' + params.dossierId, {}).then(response => {
      context.commit('editDossierState', 'ok')
      context.dispatch('listAllDossiersForAClient', { clientId: params.clientId })
    }).catch(error => {
      context.commit('editDossierState', 'error')
      ErrorMessageHelper(context, 'Impossible de supprimer le dossier client.')
      return Promise.reject(error)
    })
  }
}
